import React from 'react';
import {getSocial} from '../../../utilities/socials';

const Socials = ({only = [], socials}) => (
	<div className="social">
		<ul>
			{
				socials
					.filter(({network}) => only.includes(network))
					.map((social) => (getSocial(social, only)))
					.map((social, index) => (
						<li key={index} className={[social.hide ? "hide" : '']}>
							<a href={social.href} target="_blank"
							   className="btn-floating waves-effect waves-light white">
								<i className={`mdi mdi-${social.icon}`}/>
							</a>
						</li>
					))
			}
		</ul>
	</div>
);

export default Socials;



// WEBPACK FOOTER //
// ./src/components/elements/About/Socials.js